import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVoice = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.207 10.91A7.224 7.224 0 0 1 12 18.151a7.223 7.223 0 0 1-7.207-7.24M12 21v-2.848"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.34 10.883A3.667 3.667 0 0 0 12 14.557a3.667 3.667 0 0 0 3.658-3.675V6.659a3.659 3.659 0 0 0-7.318 0zM13.865 7.266h1.793m-2.693 3.007h2.693"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgVoice);
export default ForwardRef;
